<div class="campaign-dropdown-wrapper">

  <!-- Trigger: a field — 50px pill, a chip for the picked campaign -->
  <div class="campaign-dropdown-trigger"
       role="combobox"
       tabindex="0"
       aria-haspopup="listbox"
       [attr.aria-controls]="panelId"
       [attr.aria-expanded]="isOpen()"
       [attr.aria-label]="placeholder() | translate"
       [class.is-open]="isOpen()"
       [class.has-value]="selected() !== null"
       (click)="togglePanel($event)"
       (keydown.enter)="onTriggerKey($event)"
       (keydown.space)="onTriggerKey($event)">

    <div class="trigger-content">
      @if (selected(); as campaign) {
        <cm-ui-chip
          icon="campaign"
          [label]="campaign.name"
          removable
          [removeLabel]="'common.remove' | translate"
          (removed)="clear()" />
      } @else {
        <span class="trigger-placeholder">{{ placeholder() | translate }}</span>
      }
    </div>

    <mat-icon class="trigger-arrow" [class.open]="isOpen()">expand_more</mat-icon>
  </div>

  <!-- Panel: the field's listbox -->
  @if (isOpen()) {
    <div class="campaign-dropdown-panel" [id]="panelId" (click)="$event.stopPropagation()">

      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="panel-search">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          type="text"
          [value]="searchTerm()"
          (input)="onSearchInput($any($event.target).value)"
          [placeholder]="'ADMIN.campaignDropdown.search' | translate"
          [attr.aria-label]="'ADMIN.campaignDropdown.search' | translate"
          autofocus />
      </mat-form-field>

      <div class="panel-list" role="listbox">
        @if (loading()) {
          <cm-ui-loader />
        }
        @if (!loading() && items().length === 0) {
          <cm-ui-empty-state message="ADMIN.campaignDropdown.noResults" />
        }
        @for (item of items(); track item.uuid) {
          <div class="campaign-item"
               role="option"
               tabindex="0"
               [attr.aria-selected]="selected()?.uuid === item.uuid"
               [class.is-selected]="selected()?.uuid === item.uuid"
               (click)="select(item)"
               (keydown.enter)="select(item)"
               (keydown.space)="$event.preventDefault(); select(item)">
            <mat-icon class="item-icon">campaign</mat-icon>
            <span class="item-name">{{ item.name }}</span>
            @if (selected()?.uuid === item.uuid) {
              <mat-icon class="item-check">check</mat-icon>
            }
          </div>
        }
      </div>

    </div>
  }

</div>
